
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resume/pdf",
      function () {
        return require("private-next-pages/resume/pdf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resume/pdf"])
      });
    }
  